export default __webpack_public_path__ + "static/media/disco.d8341946.png";